// import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, Draggable, InertiaPlugin);

import { debounce as _debounce, random as _random } from 'underscore';
//import '@benmajor/jquery-touch-events';


//let console = window.console;

export default class EFFEX{

    constructor(options) {

        this.defaults = {
        	debug: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

        this.namespace = 'effx';
		this.$window = $(window);
		this.$doc = $(document);
		this.$html = $('html');
		this.$body = $('body');
		this.overshoot = 100;

		this.main = this.options.main;

		this.ids = [];

    }

	init(){

		this.addEvents( true );

		//this.initNavShowAndHide();
		this.setNavigationState();
		this.lockTimelineSidebar();
		this.lockShareButtons();
		setTimeout( ()=>this.lockSubmenuSectionsAbout(), 277 );
		setTimeout( ()=>this.initNavShowAndHide(), 177 );

		

		/*
		this.initScrollColsAtDifferentSpeed();
		this.initParallax();
		*/

		/*
		//------------------- desktop ---------------------//
		this.initNavCompact();
		this.setBurgerPin();
		

		//------------------- mobile ---------------------//
		this.setMobileHeaderPin();
		
		setTimeout( ()=>this.setBurgerMobilePin(), 0);
		

		this.setMenuSubPagesMobilePin();
		this.initMobileSubmenuPages();
		this.initSubmenuPages();

		this.initSubmenuSticky();
		setTimeout( ()=>this.checkView(), 277 );

		this.initModuleHortFiltersSticky();
		*/

		this.initGAScrollEvent()
		this.checkView()

	}

	reset(){
		this.destroy();
		this.init()
	}

	//------------------------------------------ UTILS -----------------------------------------//
	addEvents( b ){
		if ( b ){
			this.r = _debounce( ()=>{ this.onResize() }, 200 );
			this.$window.on( 'resize', this.r );
		}
		else{
			if ( this.r ){
				this.r.cancel();
				this.$window.off( 'resize', this.r );
			}
		}
	}

	onResize(){
		this.initNavShowAndHide();		
		this.lockTimelineSidebar();
		this.lockShareButtons();
		this.lockSubmenuSectionsAbout();
	}

	getWindowHeight(){
		return this.$window.height();
	}
	getDocHeight(){
		return this.$doc.height();
	}


	//------------------------------------------ GA SCROLL EVENT ---------------------------------//
	initGAScrollEvent(){
		ScrollTrigger.create({
			trigger: $('main'),
			start: "center center",
			end: "center center",
			scroller: $(this.main.options.$scroll_el),
			//scrub: true,
			//markers: true,
			id: this.getID(),
			onEnter: self =>{
				//console.log( 'enter' )
				//this.$body.addClass( 'activate-nav-compact' )
				this.main.setGAEvent( 'Scroll Activity', 'Scroll Activity', 'center', self.direction );
			},
			onEnterBack: self =>{
				//console.log( 'enter back' )
				this.main.setGAEvent( 'Scroll Activity', 'Scroll Activity', 'center', self.direction );
			}
		}) 		
	}

	
	//------------------------------------------ EFFECTS -----------------------------------------//
	initNavShowAndHide(){
		let $el = $('#desktop-header'), yTop = 0;

		this.clearExtraClasses();

		if ( this.$window.width() < 768 ){
			return;
		}

		this.$html.addClass( 'interactive-nav' );


		if ( this.$body.hasClass(  'page-template-practice-about' )  ){
			yTop = $(  '#nav-sections' ).offset().top  - 77; // - header.height()
		}

		ScrollTrigger.create({
			trigger: $el,
			start: "top top",
			end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
			//toggleClass: "activate-nav-compact",
			scrub: true,
			markers: false,
			id: this.getID(),

			/*
			onEnter: ()=>{
				//console.log( 'enter' )
				//this.$body.addClass( 'activate-nav-compact' )
			},
			onEnterBack: ()=>{
				//console.log( 'enter back' )
			},
			onLeave: ()=>{
				//this.$body.removeClass( 'activate-nav-compact' )
				//console.log( 'leave' )
			},
			*/

			onUpdate: self => {				
				let y = self.scroll(), direction = self.direction;

				// lock for home till the hero is scrolled
				if ( this.$body.hasClass( 'home' ) && this.$body.hasClass( 'navigation-white-state' ) ){
					return;
				}
				//console.log( y + ','  + yTop );
				// activate nav compact				
				if ( direction === 1 ){ // scroll down (page goes up)
					if ( y > yTop ){
						this.$body.addClass( 'hide-desktop-nav' );
					}
				}
				else{ // scrollback up (page goes up back)
					//if ( y < yback ){
						this.$body.removeClass( 'hide-desktop-nav' );
					//}
				}
			}
		})
	}

	clearExtraClasses(){
		this.$body.removeClass( 'hide-desktop-nav' );
		this.$html.removeClass( 'interactive-nav' );		
	}
	
	setNavigationState(){

		//console.log(  'setNavigationState' );

		let $el, topTrigger, $p, id = this.getID();
		if ( this.$body.hasClass( 'home' ) || this.$body.hasClass( 'page-template-ideas' ) || this.$body.hasClass( 'single-ideas' ) || this.$body.hasClass( 'tax-ideas_category' ) ){

			this.$body.addClass( 'navigation-white-state' );

			$el = $('.trigger-navigation-off-white-state');
			if ( $el.length > 0 ){

				topTrigger = 'top';
				$p = $el.prev();
				topTrigger += '-=' + $p.css( 'margin-bottom' );

				//console.log( $p.css( 'margin-bottom' ) );

				ScrollTrigger.create({
					trigger: $el,
					start: topTrigger + " top+=77px",
					end: topTrigger + " top+=77px",
					scrub: false,
					markers: false,
					id: id,

					onEnter: ()=>{
						//console.log( 'enter' )
						this.$body.removeClass( 'navigation-white-state' )
					},
					onEnterBack: ()=>{
						//console.log( 'enter back' )
						this.$body.addClass( 'navigation-white-state' )
					}
				})

			}
		}
	}

	lockTimelineSidebar(){
		let $el = $('aside .timeline-content'), end, $p, id;
		if ( $el.length > 0 ){

			if ( $el.attr('id') ){
				this.killById( $el.attr('id') );
			}

			if ( this.$window.width() > 767 ){

				if ( this.$window.height() < $el.height() ){
					return;
				}

				id = this.getID();
				$el.attr( 'id', id );

				end = $( '.sidebar-right' ).height() - ($el.offset().top - $( '.sidebar-right' ).offset().top) - $el.height() ;
				$p = $( '.module-sidebar-related-projects' );
				if ( $p.length > 0 ){
					end -= $p.height() + 100;
				}

				ScrollTrigger.create({
					trigger: $el,
					pin: true,
					pinSpacing: false,
					start: 'top+=' + $el.height()/2 + 'px center',
					end: '+=' + end,
					scrub: false,
					//markers: true,
					id: id
				})

			}
		}
		else{

			// if there is no timeline, align related project to the top of the aside column and lock as we do with share buttons

			$el = $('aside .module-sidebar-related-projects');
			if ( $el.length > 0 ){

				$el.css({
					'align-self': 'flex-start'
				})

				if ( this.$window.width() > 767 ){

					if ( this.$window.height() < $el.height() ){
						return;
					}

					id = this.getID();
					$el.attr( 'id', id );

					end = $( '.sidebar-right' ).height() - ($el.offset().top - $( '.sidebar-right' ).offset().top) - $el.height() ;

					ScrollTrigger.create({
						trigger: $el,
						pin: true,
						pinSpacing: false,
						start: 'top-=180px top',
						end: '+=' + end,
						scrub: false,
						//markers: true,
						id: id
					})

				}

			}
		}
	}

	lockShareButtons(){
		let $el = $('.sidebar-left .module-share'), end, id;
		if ( $el.length > 0 ){

			if ( $el.attr('id') ){
				this.killById( $el.attr('id') );
			}

			if ( this.$window.width() > 1023 ){

				if ( this.$window.height() < $el.height() ){
					return;
				}

				id = this.getID();
				$el.attr( 'id', id );

				end = $( '.sidebar-left' ).height() - ($el.offset().top - $( '.sidebar-left' ).offset().top) - $el.height() ;

				ScrollTrigger.create({
					trigger: $el,
					pin: true,
					pinSpacing: false,
					start: 'top-=180px top',
					end: '+=' + end,
					scrub: false,
					//markers: true,
					id: id
				})

			}
		}
	}

	lockSubmenuSectionsAbout(){


		let $el = $( '#nav-sections' ), start, id, $a, $section, offset, setDefaultSelected = false;
		if ( $el.length > 0 ){

			if ( $el.data('id') ){
				this.killById( $el.data('id') );

				for( let i=0; i< $el.find( '.menu.sections a' ).length; i++ ){
					this.killById( $el.data('id') + '-' + i );
				}

			}


			// NOT FOR MOBILE !!!!
			if ( this.$window.width() < 768 ){
				return;
			}


			id = this.getID();
			$el.data( 'id', id );

			start = this.$window.width() < 768 ? $('#mobile-header').height() : $('#desktop-header .header-bg').height();

			// if there is navigation show & hide
			if ( this.$html.hasClass( 'interactive-nav' ) && this.$window.width() >= 768 ){
				//start = 0;
			}

			ScrollTrigger.create({
				trigger: $el,
				start: "top top+=" + start + 'px', // below header
				pin: true,
				pinSpacing: false,
				end: ()=>{ return this.getDocHeight() - this.getWindowHeight() + this.overshoot },
				toggleClass: "pinned",
				scrub: true,
				markers: false,
				id: id
			});

			if ( ! setDefaultSelected ){
				id = this.getID();
				$el.data( 'id', id );

				ScrollTrigger.create({
					trigger: $('.module-page-header'),
					start: "top top",
					end: "bottom top+=" + $('.module-page-header').offset().top,
					markers: false,
					id: id,
					onEnterBack: self=>{
						this.setSelectionMenu( {trigger:null}, $el.find('.sections'), false );	
					},

				});
			}

			// this is an offset invisible after on the elements trigger, used to give necessary offset to ccompensate the fixed header
			offset = this.$window.width() < 768 ? 150 : 180;

			
			// check when the section scroll to a certain level !!!!
			$el.find( '.menu.sections a' ).each( (i,el)=>{
				$a = $(el);

				//console.log( $a );

				if ( $a.hasClass( 'menu-anchor' ) ){

					if ( i=== 0 ){
						$section  = $( $a.attr( 'href' ) );
						// set the first item seleted
						if ( setDefaultSelected ){
							this.setSelectionMenu( {trigger: $section[0]}, $el.find('.sections') );
						}
						
					}

					ScrollTrigger.create({
						trigger: $( $a.attr( 'href' ) ),
						start: "top center-=" + offset,
						end: "+=" + $( $a.attr( 'href' ) ).height(),
						markers: false,
						id: id + '-' + i,
						onEnter: self=>{
							//let $s = $el.find('.sections a[href="#' + $( self.trigger ).attr('id') + '"]');
							//$s.parent().addClass( 'active' );

							//console.log( 'enter' );
							//console.log( self );


							this.setSelectionMenu( self, $el.find('.sections') );
						},
						onLeave: self=>{
							//let $s = $el.find('.sections a[href="#' + $( self.trigger ).attr('id') + '"]');
							//$s.parent().addClass( 'active' );

							//console.log( 'leave' );
							//console.log( self );


							
						},
						onEnterBack: self=>{

							
							//console.log( 'enterBack' );
							//console.log( self );

							this.setSelectionMenu( self, $el.find('.sections') );
						},
					});

				}

			});
		}
	}

	setSelectionMenu( self, $menu, setSelection=true ){
		let hash = $( self.trigger ).attr('id'), 
			$a = $menu.find('a[href="#' + hash + '"]');

		// clear selection
		$menu.find( 'li' ).removeClass( 'active' );
		if ( setSelection ){
			// set  selection
			$a.parent( 'li' ).addClass( 'active' );			
		}
		//  change url hash
		// this.changeHashUrl( hash );
	}

	changeHashUrl( hash ){
		history.replaceState(null, null, document.location.pathname + '#' + hash );
	}

	/*
	initNavCompact(){
		let $el = $('#desktop-header');

		ScrollTrigger.create({
			trigger: $el,
			start: "top top",
			end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
			//toggleClass: "activate-nav-compact",
			scrub: true,
			markers: false,
			id: this.getID(),

			onEnter: ()=>{
				//console.log( 'enter' )
				//this.$body.addClass( 'activate-nav-compact' )
			},
			onEnterBack: ()=>{
				//console.log( 'enter back' )
			},
			onLeave: ()=>{
				//this.$body.removeClass( 'activate-nav-compact' )
				//console.log( 'leave' )
			},
			onUpdate: self => {				
				let y = self.scroll(), yback = $el.height(), direction = self.direction, $a = $('#announcement-bar');

				if ( $a.length > 0 ){
					yback += $a.height();
				}
				// activate nav compact				
				if ( direction === 1 ){
					if ( y >= yback ){
						this.$body.addClass( 'activate-nav-compact' )
					}
				}
				else if ( direction === -1 ){
					if ( y < yback + 30 ){
						this.$body.removeClass( 'activate-nav-compact' ).removeClass( 'scroll-direction-back' );
					}
				}
				
				// track direction of scrolling
				if ( this.$body.hasClass( 'activate-nav-compact' ) ){
					if ( direction === 1){
						this.$body.removeClass( 'scroll-direction-back' );
					}
					else{
						this.$body.addClass( 'scroll-direction-back' );
					}					
				}
			}
		})
	}
	*/

	/*
	setBurgerPin(){
		let $el = $('#burger');

		ScrollTrigger.create({
			trigger: $el,
			start: "top top+=10",
			pin: true,
			pinSpacing: false,
			end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
			//toggleClass: "activate-nav-compact",
			scrub: true,
			markers: false,
			id: this.getID()
		})
	}
	*/

	/*
	setMobileHeaderPin(){
		let $el = $('#mobile-header');
		if ( $el.length > 0  && !this.$body.hasClass( 'home' )  ){

			ScrollTrigger.create({
				trigger: $el,
				start: "top top",
				pin: true,
				pinSpacing: false,
				end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
				//toggleClass: "activate-nav-compact",
				scrub: true,
				markers: false,
				id: this.getID()
			})

		}
	}
	*/

	/*
	setBurgerMobilePin(){
		let $el = $('#burger-mobile');
		ScrollTrigger.create({
			trigger: $el,
			start: "top top+=5",
			pin: true,
			pinSpacing: false,
			end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
			//toggleClass: "activate-nav-compact",
			scrub: true,
			markers: false,
			id: this.getID()
		})
	}
	*/

	/*
	setMenuSubPagesMobilePin(){
		let $el = $('#submenu-pages-mobile');
		if ( $el.length > 0  ){

			ScrollTrigger.create({
				trigger: $el,
				start: "top top+=60", // below header
				pin: true,
				pinSpacing: false,
				end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
				//toggleClass: "activate-nav-compact",
				scrub: true,
				markers: false,
				id: this.getID()
			})
		}
	}
	*/

	/*
	initMobileSubmenuPages(){
		let $el = $('.submenu-pages-mobile .scroll-layer'), $c, tox;

		if ( $el.length > 0 ){

			if ( this.draggableSubmenuPages ){
				// this.draggableSubmenuPages.kill();
			}

			//  set correct width of the scroller to the menu length (+ margin to scroll below the shadow)
			$el.width( Math.ceil( $el.find( 'ul' ).width() + 70 ) );

			// set draggable
			this.draggableSubmenuPages = Draggable.create( $el, {
			    type:"x",
			    bounds: $el.parent(),
			    // THIS NEED INIERTIA PLUGIN!!!!!!!!!
			    inertia: true     
			});

			// set current selection
			setTimeout( () => {
				$c = $el.find( 'li.current-menu-item' );
				if ( $c.length > 0 ){
					tox = Math.min( $c.offset().left - 20 , $el.width() - this.$window.width() );
					//console.log( tox );
					gsap.set( $el, { x: - tox } );
				}
			}, 200 );
		}
	}
	*/

	/*
	initSubmenuPages(){
		let $el = $('.submenu-pages-desktop' ), sw, w, n, ww = this.$window.width(), d= false, $d;
		if ( $el.length > 0 ){
			sw = $el.find( '.menu.horizontal.nav-text' ).width();
			w = $el.parent().width();
			n = $el.parent().find( '.name' ).width();

			// make it not wrapping below the title
			if ( sw < w - n - 20 ){
				$el.css({
					width: 'auto'
				})
			}
			else{
				$el.width( w - n - 20 );
				d = true;
			}

			// adjust padding for small screens
			$el.css({
				'padding-top': ww<=870?3:7
			});

			// set draggable
			$d = $el.find( '.menu' );
			if ( Draggable.get($d) ){
				Draggable.get($d).kill()
			}


			if ( d ){
				$d.css({'padding-right': 70 });
				$el.find( '.shadow' ).css({opacity:1});
				Draggable.create( $d, {
				    type:"x",
				    bounds: $el,
				    // THIS NEED INIERTIA PLUGIN!!!!!!!!!
				    inertia: true     
				});

				// set current selection
				setTimeout( () => {
					let $c = $d.find( 'li.current-menu-item' ), tox;
					if ( $c.length > 0 ){
						tox = Math.min( $c.position().left , $d.width() - $el.width() );
						//console.log( tox );
						gsap.set( $d, { x: - tox } );
					}
				}, 0 );

			}
			else{
				$d.css({'padding-right': 0 });
				$el.find( '.shadow' ).css({opacity:0});
			}
		}
	}
	*/

	/*
	initModuleHortFiltersSticky(){
		let $el = $('.module-hort-filters');

		if ( $el.length > 0  ){
			ScrollTrigger.create({
				trigger: $el,
				start: "top top",
				pin: $el,
				pinSpacing: false,
				end: ()=>{ return this.getDocHeight() + 100 - this.getWindowHeight() },
				scrub: true,
				markers: false,
				id: this.getID(),
				toggleClass: 'is-sticky',
				onToggle: self =>{
					if( self.direction === 1 ){
						$( 'body' ).addClass( 'is-anchor-menu-sticky' );
					}
					else{
						$( 'body' ).removeClass( 'is-anchor-menu-sticky' );
					}
				}			
			})
		}		
	}
	*/

	/*
	initSubmenuSticky(){
		let $el = $('.submenu-pages nav.sticky');

		if ( $el.length > 0  ){

			this.$body.addClass( 'has-submenu-sticky' )

			ScrollTrigger.create({
				trigger: $el,
				start: "top top",
				pin: $el,
				pinSpacing: false,
				end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
				scrub: true,
				markers: false,
				id: this.getID(),
				onToggle: self => {
					if ( self.isActive ){
						this.$body.addClass( 'is-submenu-sticky' )
					}
					else{
						this.$body.removeClass( 'is-submenu-sticky' )
					}
				}
			})
		}
	}
	*/

	//-------------------------------------- UTILS -------------------------------//
	initParallax(){
		let $el = $('.parallax');
		if ( $el.length > 0 ){
			$el.each( (i, el)=>{
				let y = _random( -3, 5 );
				$(el).attr( 'data-parallax-yp', y );
				gsap.to( $(el), {
					yPercent: y,
					ease: "none",
					scrollTrigger: {
						trigger: $(el),
						// start: "top bottom", // the default values
						// end: "bottom top",
						scroller: $(this.main.options.$scroll_el),
						scrub: true,
						markers: false,
						id: this.getID(),
						toggleClass: 'in-view'
					} 
				})
			})
		}
	}	


	checkView(){
		let $el = $('.check-view'), widget;
		if ( $el.length > 0 ){
			$el.each( (i, el)=>{
				// we don't need the id to reference the ScrollTrigger, because once=true. So after play once it goes in Garbage collection automatically.
				ScrollTrigger.create({
					trigger: $(el),
					// start: "top bottom", // the default values
					// end: "bottom top",
					scroller: $(this.main.options.$scroll_el),
					scrub: true,
					markers: false,
					// id: this.getID(),
					toggleClass: 'in-view',
					once: true,
					onEnter: self => {
						if( $(self.trigger).hasClass( 'slideshow-set-autoplay' ) ){
							widget = $(self.trigger).data( 'widget' );
							if ( widget ){
								//console.log( widget );
								widget.setAutoplay( 7000 );
							}
						}
					}
				}) 
			})
		}
	}	

    /*
    initScrollColsAtDifferentSpeed(){
    	let $el = $('#portfolio'), $els;

    	if ( $el.length > 0 ){

    		let $col, $colfix, $c, $c1, h, h1, d;

    		// reset the container to its height (if we reinit effect on Resize )
			$el.css({
				'height': 'auto'				
			});  		

    		$c 		= $el.find( '#col1' );
    		$c1		= $el.find( '#col2' );

    		// determine the longer column ...
    		if ( $c.find('.inner').height() > $c1.find('.inner').height() ){
    			$col 	= $c;
    			$colfix = $c1;
    		}
    		else{
    			$col 	= $c1;        			
    			$colfix = $c;
    		}
    		h 	= $col.find('.inner').height();
    		h1 	= $colfix.find('.inner').height();
    		d 	= h1 - h;

    		// reset if previously intiated (Resize)
    		gsap.killTweensOf( $col );
    		gsap.set( $col, {y:0} );

    		// Scroll Trigger on longer column
			gsap.to( $col, {
			  scrollTrigger: {
			    trigger: $col,
			    start: "top top+=80px",
			    //endTrigger: $colfix.find('.inner'),
			    end: "bottom bottom",
			    //markers: true,
				toggleActions: "play none reverse none",
				//duration: $('#main').outerHeight() - $win.height(),
				scrub: true
			  },
			  y: d
			}); 

			// set container to the height of column fixed (shorter)
			$el.css({
				'height': h1 + 'px',
				'overflow': 'hidden'
			});
    	}

    	$els = $('#portfolio-mobile');

    	if ( $els.length > 0 ){
    		$els.find('.item-portfolio').off( 'tap' );
        	// mobile ------------------//
        	$els.find('.item-portfolio').on( 'tap', function(e){

        		$els.find('.item-portfolio').each(function(){
        			if ( $(this).is( $(e.currentTarget) ) ){
        				$(this).toggleClass( 'active' );
        			}
        			else{
        				$(this).removeClass('active');
        			}
        		})
        		//$(e.currentTarget).toggleClass( 'active' );
        	});
    	}

    }
	*/


	//-------------------------------------------- UTILS ------------------------------//

	getID(){
		const id = 'id_' + this.ids.length;
		this.ids.push( id );
		return id;
	}

	killById( id ){
		if ( ScrollTrigger.getById( id ) ){
			ScrollTrigger.getById( id ).kill();
		}
	}

	destroy(){
      	this.addEvents( false );
      	if ( this.ids.length ){
      		let i = this.ids.length;
      		while( i-- ){
      			this.killById( this.ids[i] );
      		}
      		this.ids = [];
      	}
      	this.clearExtraClasses();
	}
			
}



